import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { SeperatorComponent } from '../../eqform';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'eq-cnf-dialog',
  standalone: true,
  imports: [
    CommonModule,
    SeperatorComponent,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
  ],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
})
export class ConfirmationDialogComponent implements OnInit {
  header!: string;
  acceptLabel!: string;
  rejectLabel!: string;
  confirmLabel!: string;
  tipLabel: string = "";
  tip1Label: string = "";
  warnLabel: string = "";
  warn1Label: string = "";
  maybeLaterLabel: string = "";
  secondaryActionLabel: string = "";
  isSecondaryActionDisabled = false;
  pendingPaymentRiderEntries: { _id: string, riderId: string, riderName: string }[] = [];
  @Output() secondaryActionClick = new EventEmitter<void>();
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.header = this.data?.header;
    this.acceptLabel = this.data?.acceptLabel;
    this.rejectLabel = this.data?.rejectLabel;
    this.confirmLabel = this.data?.confirmLabel;
    this.tipLabel = this.data?.tip;
    this.tip1Label = this.data?.tip1;
    this.warnLabel = this.data?.warn;
    this.warn1Label = this.data?.warn1;
    this.maybeLaterLabel = this.data?.maybeLaterLabel;
    this.secondaryActionLabel = this.data?.secondaryActionLabel || '';
    this.pendingPaymentRiderEntries = this.data?.pendingPaymentRiderEntries;
  }
  accept() {
    this.dialogRef.close({ accepted: true });
  }
  onSecondaryAction(): void {
    if (this.isSecondaryActionDisabled || !this.secondaryActionLabel) {
      return;
    }
    this.secondaryActionClick.emit();
  }
  reject() {
    this.dialogRef.close(null);
  }
  goToRiderShows(riderId: string): void {
    this.router.navigate([`/profile/youth/${riderId}/shows`]);
    this.dialogRef.close(null);
  }
}
